import { clone } from 'lodash';
import { UndoAction } from './Action';
import AddItemAction from './AddItemAction';
import { DELETE_ITEM } from '../../../graphql/shopping-list';

/* eslint-disable no-underscore-dangle */

class DeleteItemAction extends UndoAction {
  constructor(options) {
    super(options);

    this.index = options.index;
    this.itemListName = options.itemListName;
    this.item = clone(this.component.shoppingList.items[this.itemListName][this.index]);
  }

  static get name() { return 'DeleteItemAction'; }

  _executeImpl() {
    const self = this;

    return this.component.$apollo.mutate({
      mutation: DELETE_ITEM,
      variables: {
        id: this.component.shoppingList.id,
        itemId: this.item.id,
        itemListName: this.itemListName,
      },
      update(store, { data: { shoppingListDeleteItem } }) {
        self._updateCache(store, shoppingListDeleteItem);
      },
      optimisticResponse: {
        shoppingListDeleteItem: {
          /* eslint-disable no-underscore-dangle */
          __typename: 'ShoppingListDeleteItemResult',
          itemId: this.item.id,
          modifiedAt: null,
        },
      },
    });
  }

  updateQuery(cachedShoppingList) {
    const itemList = cachedShoppingList.items[this.itemListName];
    const newItemList = itemList.slice(0, this.index);
    newItemList.push(...(itemList.slice(this.index + 1)));
    cachedShoppingList.items[this.itemListName] = newItemList;

    return cachedShoppingList;
  }

  undo() {
    return this.component.triggerAction(AddItemAction, {
      item: this.item,
      index: this.index,
      itemListName: this.itemListName,
      undoAction: this,
    }).then((result) => {
      this.item = result.data.shoppingListAddItem.item;
      return result;
    });
  }

  updateItem(oldItem, newItem) {
    if (this.item.id === oldItem.id) {
      this.item = clone(newItem);
    }
  }

  // eslint-disable-next-line
  undoTooltip() { return 'Undo delete item'; }

  // eslint-disable-next-line
  redoTooltip() { return 'Redo delete item'; }
}

export default DeleteItemAction;



// WEBPACK FOOTER //
// ./src/components/shopping-list/actions/DeleteItemAction.js